<fa-icon [icon]="iconName()" [size]="iconSize()" [animation]="animation()" />
